export const FIELD_TYPES = {
  BACKEND_CALLBACK: "backend_callback",
  CALLBACK_COLUMN: "callback_column",
  BLOB: "special_blob",
  BOOLEAN: "boolean",
  COLOR: "color",
  DATE: "date",
  DATETIME: "datetime",
  DEPENDED_RELATIONAL: "depended_relational",
  DROPDOWN: "dropdown",
  DROPDOWN_SEARCH: "dropdown_search",
  DYNAMIC_RELATION: "dynamic-relation",
  EMAIL: "email",
  ENUM: "enum",
  ENUM_SEARCHABLE: "enum_searchable",
  FLOAT: "float",
  HIDDEN: "hidden",
  INTEGER: "int",
  INVISIBLE: "invisible",
  MULTISELECT_NATIVE: "multiselect_native",
  MULTISELECT_SEARCHABLE: "multiselect_searchable",
  NATIVE_DATE: "native_date",
  NATIVE_DATETIME: "native_datetime",
  NATIVE_TIME: "native_time",
  NATIVE_TIMESTAMP: "native_timestamp",
  NUMERIC: "numeric",
  PASSWORD: "password",
  PASSWORD_TOGGLE: "password_toggle",
  RELATIONAL: "relational",
  RELATIONAL_NATIVE: "relational_native",
  RELATIONAL_N_N: "relational_n_n",
  RELATIONAL_N_N_AND_ORDERING: "relational_n_n_ordering",
  RELATIONAL_N_N_NATIVE: "native_relational_n_n",
  TEXT: "varchar",
  TEXTAREA: "text",
  TEXT_EDITOR: "texteditor",
  TIME: "time",
  TIMESTAMP: "timestamp",
  UPLOAD: "upload",
  UPLOAD_MULTIPLE: "upload-multiple",
};
